import React, { useState, useEffect } from "react";
import { StateContext } from "../../common/contexts";
import { FLEX } from '../../common/plans_data';
import { Router,  initialState } from './router';

const { plans, allPlansInclude } = FLEX;

const DesktopBAU = () => {
  const [ path, updatePath ] = useState(initialState);
  useEffect(() => {
    const main = document.querySelector(".main-content");
    main.className = `${main.className} -flex`;
  }, []);
  return (
    <StateContext.Provider value={ [ path, updatePath ] }>
      <Router plans={ plans } allPlansInclude={ allPlansInclude } />
    </StateContext.Provider>
  );
};

export default DesktopBAU;
